module.exports = __webpack_public_path__ + "static/kokoa-b6cfb47ce30fc9a72ba71f343cec5600.png";